// extracted by mini-css-extract-plugin
export default {"containprod":"ox","containprod2":"px","title":"qx","servings":"rx","recommendation":"sx","image":"tx","flavorswrap":"ux","flavorsgroupwrap":"vx","moredetailsWrap":"wx","infoWrap":"xx","price":"yx","regularPrice":"zx","netPrice":"Ax","addtocartcontainer":"Bx","error":"Cx"};
    if(module.hot) {
      // 1713361650602
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  